import { AppTimeSeriesCubeMetric, CubeTimeDimensionGranularity, Weekdays } from "../../../enum/cube-schema.enum";
import { CubeConfigDto } from "../../common/request/cube-config.dto";

export interface QueryAppTimeSeriesRequestParamsDto {
    startDate: string;
    endDate: string;
    granularity: CubeTimeDimensionGranularity;
    weekday?: Weekdays;
    appId: string;
    metric: AppTimeSeriesCubeMetric;
}